$("#privacy-policy-link").click(function () {
    $("#privacy-policy")[0].click();
});